import { keyboardKeyNames, Popover } from "@amzn/storm-ui";
import DatePicker, { DatePickerInput } from "@amzn/storm-ui-date-picker";
import * as React from "react";

import { LabelEndComponent } from "./LabelEndComponent";

export interface DateComponentProps {
    dimension: string;
    label: string;
    value: string;
    startDate?: Date;
    endDate?: Date;
    disabled: boolean;
    setValue: (e: string) => void;
    optional?: boolean;
    tooltip?: string;
}

export const DateComponent: React.FunctionComponent<DateComponentProps> = (
    props,
) => {
    const {
        dimension,
        label,
        value,
        setValue,
        startDate,
        endDate,
        disabled,
        optional,
        tooltip,
    } = props;
    const [activeDatePicker, setActiveDatePicker] = React.useState(false);

    const triggerRef = React.useRef<HTMLInputElement>(null);

    const handleTogglePopover = () => {
        setActiveDatePicker(!activeDatePicker);
    };

    const handleDateSelect = (newDate: Date) => {
        setValue(newDate.toString());
        handleTogglePopover();
    };

    const handleClosePopover = () => {
        setActiveDatePicker(false);
    };

    const handleClick = () => {
        handleTogglePopover();
    };

    const handleKeyDownInput = (event: React.KeyboardEvent) => {
        if (event.key === (keyboardKeyNames.ESCAPE as string)) {
            event.preventDefault();
            handleClosePopover();
        }
    };

    const labelEndProps = { tooltip, optional };

    return (
        <>
            <Popover
                data-testid={`${dimension}-popover`}
                isOpen={activeDatePicker}
                onCloseButtonClick={handleTogglePopover}
                position="bottom"
                align="start"
                autoFocus
                onKeyDown={handleKeyDownInput}
                trigger={triggerRef}
            >
                <DatePicker
                    onChange={handleDateSelect}
                    date={value.length === 0 ? undefined : new Date(value)}
                    minDate={startDate}
                    maxDate={endDate}
                />
            </Popover>
            <DatePickerInput
                data-testid={`${dimension}-date-picker`}
                id="date-picker"
                label={label}
                renderLabelEnd={<LabelEndComponent {...labelEndProps} />}
                readOnly
                value={value.length === 0 ? `Select ${label}` : value}
                onKeyDownPrefix={() => {}}
                onKeyUpPrefix={() => {}}
                disabled={disabled}
                prefixAriaLabel="select date"
                fullWidth
                onClick={handleClick}
                onKeyDown={handleKeyDownInput}
                inputRef={triggerRef}
            />
        </>
    );
};
